import { style } from '@vanilla-extract/css';
import { spacingVars } from '@tundr/ds-foundations';

export const tableActionsWrapperClass = style({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: spacingVars.xs,
});
